import { motion } from "framer-motion";
import { QrCode, ScanLine } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { imgUrl } from "../lib/api";

const DEFAULT_IMG =
  "https://landerpharma.com.py/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTQsInB1ciI6ImJsb2JfaWQifX0=--c66d477d381de3179ce35adcd0a42d2151230b62/mobile_image.png";

const STORES = [
  {
    name: "Google Play",
    img: "https://landerpharma.com.py/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTUsInB1ciI6ImJsb2JfaWQifX0=--a79bf13c5e0ef5028cc2739729ee0f0393493387/googleplay.png",
    url: "https://play.google.com/store/apps/details?id=py.com.landerlan",
    testid: "store-badge-google-play",
  },
  {
    name: "App Store",
    img: "https://landerpharma.com.py/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTYsInB1ciI6ImJsb2JfaWQifX0=--949f7fb0af362451c00497704be3d5ea6f083fb4/applestore.png",
    url: "https://apps.apple.com/py/app/landerlan/id1079044962",
    testid: "store-badge-app-store",
  },
];

export default function Showcase() {
  const content = useContent();
  const s = content.app_section;
  const img = content.app_image ? imgUrl(content.app_image) : DEFAULT_IMG;

  return (
    <section id="app" className="py-24 lg:py-32" data-testid="app-showcase-section">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative order-2 lg:order-1"
        >
          <div className="flex items-center justify-center overflow-hidden rounded-3xl border border-[#E8E4D9] bg-ivory">
            <img src={img} alt="App móvil Landerlan" className="max-h-[480px] w-full object-contain py-6" />
          </div>
          <div className="glass absolute -right-4 -top-6 flex items-center gap-3 rounded-2xl border border-[#E8E4D9] p-4 shadow-lg sm:-right-8" data-testid="qr-verifier-card">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-light text-brand">
              <ScanLine size={22} />
            </div>
            <div>
              <p className="font-display text-sm font-bold text-neutral-900">Verificador de lote</p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-brand">
                QR · Autenticidad RD
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="order-1 lg:order-2"
        >
          <p className="font-mono mb-4 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-brand">
            <QrCode size={14} /> App Landerlan
          </p>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-neutral-900 sm:text-3xl lg:text-4xl">
            {s.title}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-neutral-500 sm:text-base">
            {s.text}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            {STORES.map((store) => (
              <a
                key={store.name}
                href={store.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={store.testid}
                className="transition-transform duration-200 hover:scale-105"
              >
                <img src={store.img} alt={`Descargar en ${store.name}`} className="h-12 w-auto" />
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
